import type { ComponentProps } from 'react'
import { cn } from '@cocoonspace/ui/lib/utils'

export const MainContainer = ({
	children,
	className,
	...props
}: ComponentProps<'div'>) => (
	<div
		{...props}
		className={cn(
			'relative container mx-auto flex min-h-[calc(100dvh-var(--app-navbar-height))] flex-col gap-y-6 py-6 max-md:overflow-y-auto',
			className,
		)}
	>
		{children}
	</div>
)
